<template lang="pug">
h1.text-center 歡迎使用管理系統
</template>

<script>

export default {
  name: 'Home'
}
</script>

<style scoped lang="scss">
</style>
